import React, { useState } from 'react';
import { BarChart3Icon, PieChartIcon, DownloadIcon, CalendarIcon, ArrowUpRightIcon, FilterIcon, FileSpreadsheetIcon, FileTextIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, DollarSignIcon, RefreshCwIcon } from 'lucide-react';
export function ReportsPage() {
  const [activeTab, setActiveTab] = useState('overview');
  const [filterDept, setFilterDept] = useState('all');
  const [filterPeriod, setFilterPeriod] = useState('30d');
  const tabs = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'tickets',
    label: 'Tickets Issued'
  }, {
    id: 'ancillary',
    label: 'Ancillary Services'
  }, {
    id: 'refunds',
    label: 'Refunds'
  }, {
    id: 'reconciliation',
    label: 'Reconciliation'
  }];
  const monthlyData = [{
    month: 'May',
    amount: 45000,
    height: 'h-32'
  }, {
    month: 'Jun',
    amount: 52000,
    height: 'h-40'
  }, {
    month: 'Jul',
    amount: 48000,
    height: 'h-36'
  }, {
    month: 'Aug',
    amount: 61000,
    height: 'h-48'
  }, {
    month: 'Sep',
    amount: 55000,
    height: 'h-44'
  }, {
    month: 'Oct',
    amount: 68000,
    height: 'h-56'
  }];
  const ticketData = [{
    id: 'TKT-001',
    traveler: 'David Miller',
    route: 'JFK → SFO',
    airline: 'United Airlines',
    pnr: 'XKJF82',
    date: 'Nov 10, 2024',
    amount: '$1,850',
    status: 'Issued'
  }, {
    id: 'TKT-002',
    traveler: 'Sarah Jenkins',
    route: 'ORD → LAX',
    airline: 'Delta',
    pnr: 'MNOP45',
    date: 'Nov 09, 2024',
    amount: '$950',
    status: 'Issued'
  }, {
    id: 'TKT-003',
    traveler: 'Michael Chen',
    route: 'JFK → AUS',
    airline: 'Delta',
    pnr: 'QRST67',
    date: 'Nov 08, 2024',
    amount: '$1,200',
    status: 'Issued'
  }, {
    id: 'TKT-004',
    traveler: 'Lisa Park',
    route: 'SFO → JFK',
    airline: 'American',
    pnr: 'UVWX89',
    date: 'Nov 07, 2024',
    amount: '$780',
    status: 'Issued'
  }, {
    id: 'TKT-005',
    traveler: 'James Wilson',
    route: 'LAX → SEA',
    airline: 'Alaska',
    pnr: 'YZAB12',
    date: 'Nov 06, 2024',
    amount: '$420',
    status: 'Issued'
  }];
  const reconciliationData = [{
    bookingId: 'BK-7829',
    traveler: 'Sarah Connor',
    bookingAmount: '$1,240',
    paymentAmount: '$1,240',
    paymentStatus: 'Matched',
    paymentDate: 'Oct 24, 2024'
  }, {
    bookingId: 'BK-7830',
    traveler: 'John Smith',
    bookingAmount: '$850',
    paymentAmount: '$850',
    paymentStatus: 'Matched',
    paymentDate: 'Oct 25, 2024'
  }, {
    bookingId: 'BK-7831',
    traveler: 'David Miller',
    bookingAmount: '$1,850',
    paymentAmount: '$0',
    paymentStatus: 'Pending',
    paymentDate: '-'
  }, {
    bookingId: 'BK-7832',
    traveler: 'Lisa Park',
    bookingAmount: '$650',
    paymentAmount: '$650',
    paymentStatus: 'Matched',
    paymentDate: 'Nov 01, 2024'
  }, {
    bookingId: 'BK-7833',
    traveler: 'Mike Ross',
    bookingAmount: '$1,100',
    paymentAmount: '$550',
    paymentStatus: 'Partial',
    paymentDate: 'Nov 03, 2024'
  }];
  return <div className="space-y-6" data-id="element-2341">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-2342">
        <div data-id="element-2343">
          <h2 className="text-2xl font-bold text-navy-900" data-id="element-2344">
            Reports & Analytics
          </h2>
          <p className="text-slate-500" data-id="element-2345">
            Deep dive into travel patterns, expenses, and reconciliation.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-2346">
          <select value={filterPeriod} onChange={e => setFilterPeriod(e.target.value)} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm focus:border-navy-600 focus:outline-none" data-id="element-2347">
            <option value="7d" data-id="element-2348">Last 7 Days</option>
            <option value="30d" data-id="element-2349">Last 30 Days</option>
            <option value="90d" data-id="element-2350">Last Quarter</option>
            <option value="ytd" data-id="element-2351">Year to Date</option>
          </select>
          <select value={filterDept} onChange={e => setFilterDept(e.target.value)} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm focus:border-navy-600 focus:outline-none" data-id="element-2352">
            <option value="all" data-id="element-2353">All Departments</option>
            <option value="engineering" data-id="element-2354">Engineering</option>
            <option value="sales" data-id="element-2355">Sales</option>
            <option value="marketing" data-id="element-2356">Marketing</option>
          </select>
          <button className="flex items-center rounded-lg border border-emerald-300 bg-emerald-50 px-4 py-2 text-sm font-medium text-emerald-700 hover:bg-emerald-100 transition-colors" data-id="element-2357">
            <FileSpreadsheetIcon className="mr-2 h-4 w-4" data-id="element-2358" />
            Excel
          </button>
          <button className="flex items-center rounded-lg border border-red-300 bg-red-50 px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-100 transition-colors" data-id="element-2359">
            <FileTextIcon className="mr-2 h-4 w-4" data-id="element-2360" />
            PDF
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2361">
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-2362">
          <div className="flex items-center gap-2 mb-2" data-id="element-2363">
            <div className="h-8 w-8 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-2364">
              <CheckCircleIcon className="h-4 w-4 text-blue-600" data-id="element-2365" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2366">
              Total Tickets
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2367">1,248</p>
          <p className="text-xs text-emerald-600 font-medium mt-1" data-id="element-2368">
            +12% vs last period
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-2369">
          <div className="flex items-center gap-2 mb-2" data-id="element-2370">
            <div className="h-8 w-8 rounded-full bg-purple-50 flex items-center justify-center" data-id="element-2371">
              <RefreshCwIcon className="h-4 w-4 text-purple-600" data-id="element-2372" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2373">
              Total Refunds
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2374">$18,450</p>
          <p className="text-xs text-slate-500 mt-1" data-id="element-2375">23 refund transactions</p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-2376">
          <div className="flex items-center gap-2 mb-2" data-id="element-2377">
            <div className="h-8 w-8 rounded-full bg-amber-50 flex items-center justify-center" data-id="element-2378">
              <ClockIcon className="h-4 w-4 text-amber-600" data-id="element-2379" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2380">
              Outstanding
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2381">$12,500</p>
          <p className="text-xs text-amber-600 font-medium mt-1" data-id="element-2382">
            5 pending payments
          </p>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-id="element-2383">
          <div className="flex items-center gap-2 mb-2" data-id="element-2384">
            <div className="h-8 w-8 rounded-full bg-emerald-50 flex items-center justify-center" data-id="element-2385">
              <DollarSignIcon className="h-4 w-4 text-emerald-600" data-id="element-2386" />
            </div>
            <span className="text-xs font-semibold text-slate-500 uppercase" data-id="element-2387">
              Total Spend
            </span>
          </div>
          <p className="text-2xl font-bold text-navy-900" data-id="element-2388">$482,500</p>
          <p className="text-xs text-emerald-600 font-medium mt-1" data-id="element-2389">
            +8.2% vs last year
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-1 bg-slate-100 rounded-lg p-1 overflow-x-auto" data-id="element-2390">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${activeTab === tab.id ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-2391">
            {tab.label}
          </button>)}
      </div>

      {activeTab === 'overview' && <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-2392">
          {/* Spend by Category */}
          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2393">
            <h3 className="mb-6 font-semibold text-navy-900" data-id="element-2394">
              Spend by Category
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8" data-id="element-2395">
              <div className="relative h-48 w-48 rounded-full" style={{
            background: 'conic-gradient(#1e3a5f 0% 45%, #10b981 45% 75%, #d4a853 75% 90%, #64748b 90% 100%)'
          }} data-id="element-2396">
                <div className="absolute inset-0 m-auto h-32 w-32 rounded-full bg-white flex items-center justify-center flex-col" data-id="element-2397">
                  <span className="text-2xl font-bold text-navy-900" data-id="element-2398">
                    $329k
                  </span>
                  <span className="text-xs text-slate-500" data-id="element-2399">Total YTD</span>
                </div>
              </div>
              <div className="space-y-3 w-full sm:w-auto" data-id="element-2400">
                <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-2401">
                  <div className="h-3 w-3 rounded-full bg-navy-700" data-id="element-2402" />
                  <span className="text-sm text-slate-600 w-24" data-id="element-2403">Flights</span>
                  <span className="text-sm font-semibold text-navy-900" data-id="element-2404">
                    45%
                  </span>
                </div>
                <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-2405">
                  <div className="h-3 w-3 rounded-full bg-emerald-500" data-id="element-2406" />
                  <span className="text-sm text-slate-600 w-24" data-id="element-2407">Hotels</span>
                  <span className="text-sm font-semibold text-navy-900" data-id="element-2408">
                    30%
                  </span>
                </div>
                <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-2409">
                  <div className="h-3 w-3 rounded-full bg-gold-500" data-id="element-2410" />
                  <span className="text-sm text-slate-600 w-24" data-id="element-2411">Transport</span>
                  <span className="text-sm font-semibold text-navy-900" data-id="element-2412">
                    15%
                  </span>
                </div>
                <div className="flex items-center justify-between sm:justify-start gap-3" data-id="element-2413">
                  <div className="h-3 w-3 rounded-full bg-slate-500" data-id="element-2414" />
                  <span className="text-sm text-slate-600 w-24" data-id="element-2415">Other</span>
                  <span className="text-sm font-semibold text-navy-900" data-id="element-2416">
                    10%
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Monthly Spend Trend */}
          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2417">
            <div className="flex items-center justify-between mb-6" data-id="element-2418">
              <h3 className="font-semibold text-navy-900" data-id="element-2419">
                Monthly Spend Trend
              </h3>
              <div className="flex items-center text-sm text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full" data-id="element-2420">
                <ArrowUpRightIcon className="h-4 w-4 mr-1" data-id="element-2421" />
                <span data-id="element-2422">+12.5% vs last year</span>
              </div>
            </div>
            <div className="flex h-48 items-end justify-between gap-2 pt-4" data-id="element-2423">
              {monthlyData.map(item => <div key={item.month} className="flex flex-col items-center gap-2 w-full group" data-id="element-2424">
                  <div className="relative w-full flex justify-center" data-id="element-2425">
                    <span className="absolute -top-8 text-xs font-medium text-navy-900 opacity-0 group-hover:opacity-100 transition-opacity bg-white shadow-sm border border-slate-200 px-2 py-1 rounded" data-id="element-2426">
                      ${(item.amount / 1000).toFixed(1)}k
                    </span>
                    <div className={`w-full max-w-[40px] rounded-t-md bg-navy-700 hover:bg-navy-600 transition-colors ${item.height}`} data-id="element-2427" />
                  </div>
                  <span className="text-xs font-medium text-slate-500" data-id="element-2428">
                    {item.month}
                  </span>
                </div>)}
            </div>
          </div>
        </div>}

      {activeTab === 'tickets' && <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-2429">
          <div className="border-b border-slate-200 px-6 py-4" data-id="element-2430">
            <h3 className="font-semibold text-navy-900" data-id="element-2431">Tickets Issued</h3>
          </div>
          <div className="overflow-x-auto" data-id="element-2432">
            <table className="w-full text-left text-sm" data-id="element-2433">
              <thead className="bg-slate-50 text-slate-500" data-id="element-2434">
                <tr data-id="element-2435">
                  <th className="px-6 py-3 font-medium" data-id="element-2436">Ticket ID</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2437">Traveler</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2438">Route</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2439">Airline</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2440">PNR</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2441">Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2442">Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2443">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-2444">
                {ticketData.map(ticket => <tr key={ticket.id} className="hover:bg-slate-50" data-id="element-2445">
                    <td className="px-6 py-4 font-mono text-xs font-bold text-navy-700" data-id="element-2446">
                      {ticket.id}
                    </td>
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2447">
                      {ticket.traveler}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2448">{ticket.route}</td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2449">
                      {ticket.airline}
                    </td>
                    <td className="px-6 py-4 font-mono text-xs text-slate-500" data-id="element-2450">
                      {ticket.pnr}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2451">{ticket.date}</td>
                    <td className="px-6 py-4 font-bold text-slate-900" data-id="element-2452">
                      {ticket.amount}
                    </td>
                    <td className="px-6 py-4" data-id="element-2453">
                      <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700" data-id="element-2454">
                        {ticket.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {activeTab === 'reconciliation' && <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-2455">
          <div className="border-b border-slate-200 px-6 py-4" data-id="element-2456">
            <h3 className="font-semibold text-navy-900" data-id="element-2457">
              Booking vs Payment Reconciliation
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-2458">
            <table className="w-full text-left text-sm" data-id="element-2459">
              <thead className="bg-slate-50 text-slate-500" data-id="element-2460">
                <tr data-id="element-2461">
                  <th className="px-6 py-3 font-medium" data-id="element-2462">Booking ID</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2463">Traveler</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2464">Booking Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2465">Payment Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2466">Payment Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2467">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-2468">
                {reconciliationData.map(row => <tr key={row.bookingId} className="hover:bg-slate-50" data-id="element-2469">
                    <td className="px-6 py-4 font-mono text-xs font-bold text-navy-700" data-id="element-2470">
                      {row.bookingId}
                    </td>
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2471">
                      {row.traveler}
                    </td>
                    <td className="px-6 py-4 text-slate-900 font-bold" data-id="element-2472">
                      {row.bookingAmount}
                    </td>
                    <td className="px-6 py-4 text-slate-900 font-bold" data-id="element-2473">
                      {row.paymentAmount}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2474">
                      {row.paymentDate}
                    </td>
                    <td className="px-6 py-4" data-id="element-2475">
                      <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${row.paymentStatus === 'Matched' ? 'bg-emerald-100 text-emerald-700' : row.paymentStatus === 'Pending' ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'}`} data-id="element-2476">
                        {row.paymentStatus}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {(activeTab === 'ancillary' || activeTab === 'refunds') && <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-2477">
          <div className="border-b border-slate-200 px-6 py-4" data-id="element-2478">
            <h3 className="font-semibold text-navy-900" data-id="element-2479">
              {activeTab === 'ancillary' ? 'Ancillary Services' : 'Refund Details'}
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-2480">
            <table className="w-full text-left text-sm" data-id="element-2481">
              <thead className="bg-slate-50 text-slate-500" data-id="element-2482">
                <tr data-id="element-2483">
                  <th className="px-6 py-3 font-medium" data-id="element-2484">Category</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2485">Vendor</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2486">Transactions</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2487">Total Spend</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2488">Avg. Ticket</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2489">
                {activeTab === 'ancillary' ? <>
                    <tr className="hover:bg-slate-50" data-id="element-2490">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2491">
                        Seat Upgrades
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2492">
                        Various Airlines
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2493">89</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2494">
                        $12,450
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2495">$140</td>
                    </tr>
                    <tr className="hover:bg-slate-50" data-id="element-2496">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2497">
                        Extra Baggage
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2498">
                        Various Airlines
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2499">156</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2500">
                        $7,800
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2501">$50</td>
                    </tr>
                    <tr className="hover:bg-slate-50" data-id="element-2502">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2503">
                        Travel Insurance
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2504">AIG Travel</td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2505">342</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2506">
                        $17,100
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2507">$50</td>
                    </tr>
                    <tr className="hover:bg-slate-50" data-id="element-2508">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2509">
                        Lounge Access
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2510">
                        Priority Pass
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2511">67</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2512">
                        $2,345
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2513">$35</td>
                    </tr>
                  </> : <>
                    <tr className="hover:bg-slate-50" data-id="element-2514">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2515">
                        Flight Cancellation
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2516">
                        United Airlines
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2517">12</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2518">
                        $8,400
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2519">$700</td>
                    </tr>
                    <tr className="hover:bg-slate-50" data-id="element-2520">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2521">
                        Hotel Cancellation
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2522">Marriott</td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2523">8</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2524">
                        $4,200
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2525">$525</td>
                    </tr>
                    <tr className="hover:bg-slate-50" data-id="element-2526">
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2527">
                        Car Rental Refund
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2528">Hertz</td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2529">3</td>
                      <td className="px-6 py-4 font-medium text-slate-900" data-id="element-2530">
                        $850
                      </td>
                      <td className="px-6 py-4 text-slate-600" data-id="element-2531">$283</td>
                    </tr>
                  </>}
              </tbody>
            </table>
          </div>
        </div>}

      {/* Scheduled Reports */}
      <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2532">
        <h3 className="font-semibold text-navy-900 mb-4" data-id="element-2533">Scheduled Reports</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2534">
          <div className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2535">
            <h4 className="font-medium text-slate-900 text-sm" data-id="element-2536">
              Weekly Summary
            </h4>
            <p className="text-xs text-slate-500 mt-1" data-id="element-2537">
              Every Monday at 9:00 AM
            </p>
            <p className="text-xs text-emerald-600 font-medium mt-2" data-id="element-2538">Active</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2539">
            <h4 className="font-medium text-slate-900 text-sm" data-id="element-2540">
              Monthly Reconciliation
            </h4>
            <p className="text-xs text-slate-500 mt-1" data-id="element-2541">1st of every month</p>
            <p className="text-xs text-emerald-600 font-medium mt-2" data-id="element-2542">Active</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2543">
            <h4 className="font-medium text-slate-900 text-sm" data-id="element-2544">
              Quarterly Budget Review
            </h4>
            <p className="text-xs text-slate-500 mt-1" data-id="element-2545">End of each quarter</p>
            <p className="text-xs text-emerald-600 font-medium mt-2" data-id="element-2546">Active</p>
          </div>
        </div>
      </div>
    </div>;
}